import api from '@/services/api';

const projectActions = {
  async getProjectSketches(store, { projectId }) {
    const r = await api.get(`v2/drawings-projects/${projectId}`);
    return r.data.data;
  },
  async createProjectSketch({ dispatch }, { projectId, body }) {
    await api.post(`v2/drawings-projects/${projectId}`, body);
    return await dispatch('getProjectSketches', { projectId });
  },
  async removeProjectSketch({ dispatch }, { projectId, sketches }) {
    await api.delete(`v2/drawings-projects/${projectId}`, { data: sketches });
    return await dispatch('getProjectSketches', { projectId });
  },
};

const featureActions = {
  async getFeatureSketches(store, { datasource, featureId }) {
    const r = await api.get(`v2/drawings-datasources/${datasource}/${featureId}`);
    return r.data.data;
  },
  async createFeatureSketch({ dispatch }, { datasource, featureId, body }) {
    await api.post(`v2/drawings-datasources/${datasource}/${featureId}`, body);
    return await dispatch('getFeatureSketches', { datasource, featureId });
  },
  async removeFeatureSketch({ dispatch }, { datasource, featureId, sketches }) {
    await api.delete(`v2/drawings-datasources/${datasource}/${featureId}`, { data: sketches });
    return await dispatch('getFeatureSketches', { datasource, featureId });
  },
};

export default {
  namespaced: true,
  actions: {
    ...projectActions,
    ...featureActions,
  },
};
